import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const IciciReconciliationModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  submitted, reconciliationMode,
  // event handlers
  onSubmit, onCancelClick,
  //
  bankStatementTransactionId, onbankStatementTransactionIdChange, bankStatementTransactionIdError, setbankStatementTransactionIdError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Copy ICICI Transaction'
    buttonLabel='Copy'
    cancelLabel='Cancel'
    isOpen={reconciliationMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='bankStatementTransactionId' label='Bank Statement Transaction Id'
      required={true} maxLength={100} autoFocus={true}
      value={bankStatementTransactionId} onChange={onbankStatementTransactionIdChange}
      error={bankStatementTransactionIdError} setError={setbankStatementTransactionIdError}
    />
  </ModalFormUI>

export default IciciReconciliationModalUI
